import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';
import { Typography } from '../Typography/index.js';

export type ListItemTextElement = FlexElement;
export interface ListItemTextProps extends FlexProps {
  title: string;
  subtitle?: string;
}
export const ListItemText = styled(
  forwardRef<ListItemTextElement, ListItemTextProps>(({ title, subtitle, ...restProps }, ref) => {
    return (
      <Flex ref={ref} column minWidth={0} width="100%" {...restProps}>
        <Typography ellipsis noWrap variant="title">
          {title}
        </Typography>
        {subtitle && (
          <Typography ellipsis noWrap variant="body">
            {subtitle}
          </Typography>
        )}
      </Flex>
    );
  })
).withConfig({
  displayName: 'ListItemText',
})``;
